import {ubcLogger} from '@baidu/ubc-report-sdk';

export type LogType =
    | 'display'
    | 'click'
    | 'show'
    | 'hover'
    | 'duration'
    | 'system'
    | 'create'
    | 'time'
    | 'info'
    | 'input';
export type LogExt = Record<string, string | number | string[] | boolean>;

export interface InitLogParams {
    page?: string;
    testMode?: boolean;
}

export interface LogParams {
    from?: string;
    type?: LogType;
    value?: string;
    page?: string;
    source?: string;
    ext?: LogExt;
}

export interface SendLogOptions {
    useSendBeacon?: boolean;
    useXhr?: boolean;
    sendMethod?: 'get' | 'post';
}

const APP_NAME = 'ai_drama_creation_platform';
export const UBC_SERVER_ID = '20154';

let inited = false;
let currentPage = 'home';

export const getAppName = (): string => APP_NAME;

export const initLog = ({page = currentPage, testMode}: InitLogParams): void => {
    currentPage = page;

    ubcLogger.set({
        serverId: UBC_SERVER_ID,
        page,
        queryParams: {
            appname: APP_NAME,
        },
        testMode: testMode ?? false,
        sendBetaParams: false,
    });
    inited = true;
};

export const setLogPage = (page: string): void => {
    currentPage = page;

    if (inited) {
        ubcLogger.set({page});
    }
};

export const sendLog = (params: LogParams, options?: SendLogOptions): void => {
    if (!inited) {
        return;
    }

    try {
        void ubcLogger
            .send(
                {
                    type: params.type ?? 'info',
                    value: params.value ?? '',
                    page: params.page ?? currentPage,
                    from: params.from,
                    source: params.source,
                    ext: params.ext,
                },
                options,
            )
            .catch(() => undefined);
    } catch {
        // 埋点失败不阻塞业务。
    }
};

export const sendClickLog = (params: Omit<LogParams, 'type'>, options?: SendLogOptions): void => {
    sendLog({...params, type: 'click'}, options);
};

export const sendShowLog = (params: Omit<LogParams, 'type'>, options?: SendLogOptions): void => {
    sendLog({...params, type: 'show'}, options);
};

export const sendInputLog = (params: Omit<LogParams, 'type'>, options?: SendLogOptions): void => {
    sendLog({...params, type: 'input'}, options);
};

export const sendDisplayLog = (
    params: Omit<LogParams, 'type'> = {},
    options?: SendLogOptions,
): void => {
    sendLog({...params, type: 'display'}, options);
};

export const sendDurationLog = (
    params: Omit<LogParams, 'type'>,
    options?: SendLogOptions,
): void => {
    sendLog({...params, type: 'duration'}, options);
};

export const sendSystemLog = (params: Omit<LogParams, 'type'>, options?: SendLogOptions): void => {
    sendLog({...params, type: 'system'}, options);
};
